<template lang="pug">
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title(v-model="title") {{ title }}
            v-divider(class="mx-2" inset vertical)
            v-spacer
          v-divider
          FormVisitor 
</template>

<script>
import FormVisitor from '../components/FormVisitor.vue'
export default {
name :'AddVisitor',
components: {
  FormVisitor
},
data (){
    return {
        title: 'Tambah Visitor',
    }
}
}
</script>

<style>

</style>